import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'return'
})
export class ReturnPipe implements PipeTransform {

  transform(value: any, returnValue: any): unknown {
    return returnValue;
  }

}
